const KLAVIYO_API_KEY = 'YjSEC4'; 
/* 
    public key, safe to expose
    access within Klaviyo app at account > settings > API keys
    custom bis based off this support thread: 
    https://community.klaviyo.com/integrations-39/custom-back-in-stock-form-shopify-925 

    BIS Implementation: https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
    Client Subscription Implementation: https://developers.klaviyo.com/en/reference/create_client_subscription
*/

if (!customElements.get('klaviyo-back-in-stock-form')) {
    class KlaviyoBISForm extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            [...this.querySelectorAll('form')].forEach((form) => form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.variantId = document.querySelector('select[data-main-select]').value;
                this.email = this.querySelector('[data-email-field]')?.value;

                if(!this.variantId || !this.email) return;
                this.closest('right-drawer')?.classList.add('loading');
                this.postForm().then(() => {
                    this.closest('right-drawer')?.classList.remove('loading');
                });
            }));
        }

        postForm = async() => {
          const data = {
            'type': 'back-in-stock-subscription',
            'attributes': {
                'profile': {
                    'data': {
                        'type': 'profile',
                        'attributes': {
                            'email': `${this.email}`
                        }
                    }
                },
                "channels": ["EMAIL"],
            },
            'relationships': {
                'variant': {
                    'data': {
                        'type': 'catalog-variant',
                        'id': `$shopify:::$default:::${this.variantId}`
                    }
                }
            }
          };
          
          await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_API_KEY}`, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-02-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({ data })
        }).then(res => {
          if (res.ok) {
            this.innerHTML = `<div class="block text-lg pb-10">Thanks! We'll let you know when this item is back in stock.</div>`;
          }
        }).catch((err) => {
            this.innerHTML = `<div class="block text-lg text-accent1">Unable to add this item to your restock list.</div>`;
            console.error(err);
        });
      }
    }
  
    customElements.define('klaviyo-back-in-stock-form', KlaviyoBISForm);
  }